(() => {
  let activeHandle = "allgemein";
  const icons = document.querySelectorAll(".js-faq__icon");
  let currentlyActiveIcon = document.querySelector(".js-faq__icon.active");

  const getActiveDetails = () => document.querySelectorAll(`.js-faq[data-handle="${activeHandle}"] details`);

  const togglePlus = (detail) => {
    const plus = detail.querySelector(".js-accordion__plus");
    plus.textContent = detail.open ? "-" : "+";
  };

  const showActiveFaq = (handle) => {
    document
      .querySelectorAll(".js-faq")
      .forEach((faq) => faq.classList.toggle("hidden", faq.dataset.handle !== handle));
  };

  const handleIconClick = (icon) => {
    if (currentlyActiveIcon) {
      currentlyActiveIcon.classList.remove("active");
    }

    icon.classList.add("active");
    currentlyActiveIcon = icon;

    const { handle } = icon.dataset;
    const previouslyActiveDetails = getActiveDetails();
    activeHandle = handle;
    const activeDetails = getActiveDetails();
    showActiveFaq(handle);

    previouslyActiveDetails.forEach((detail) => detail.removeEventListener("toggle", () => togglePlus(detail)));
    activeDetails.forEach((detail) => detail.addEventListener("toggle", () => togglePlus(detail)));
  };

  const init = () => {
    const activeDetails = getActiveDetails();
    activeDetails.forEach((detail) => detail.addEventListener("toggle", () => togglePlus(detail)));
    icons.forEach((icon) => icon.addEventListener("click", () => handleIconClick(icon)));
    showActiveFaq(activeHandle);
  };

  init();
})();
